/**
 * @file Projects
 */

import vFilters from '../../components/filters/filters';

/**
 * Projects functions
 *
 * Runs js specific to the Projects template
 */
const vProjects = () => {
	vFilters();
};

if ( document.readyState !== 'loading' ) {
	vProjects();
} else {
	document.addEventListener( 'DOMContentLoaded', vProjects );
}
